import { useEffect, useMemo, useState } from 'react';
import { fetchNombres } from 'services/adminService';

// { uuid: nombre } para los ids dados, vía la RPC cables_nombres. Mientras
// carga (o si la RPC no existe) devuelve lo que tenga; quien lo usa muestra el
// UUID corto con nombreUsuario() de lib/auditoria.
export default function useNombres(ids) {
  const clave = useMemo(() => [...new Set((ids || []).filter(Boolean))].sort().join(','), [ids]);
  const [nombres, setNombres] = useState({});
  useEffect(() => {
    if (!clave) return undefined;
    let vivo = true;
    fetchNombres(clave.split(',')).then((m) => { if (vivo) setNombres((n) => ({ ...n, ...m })); });
    return () => { vivo = false; };
  }, [clave]);
  return nombres;
}
